import { FC, memo } from 'react';
import { Tooltip } from 'antd';
import SiteMenu from '../SiteMenu/SiteMenu';
import Blocks from '../Blocks/Blocks';
import { BlacklistTable } from './BlacklistTable/BlacklistTable';
import { useBlacklist } from '../../hooks/components/useBlacklist/useBlacklist';
import { BlacklistTableFilter } from './BlacklistTable/BlacklistTableFilter/BlacklistTableFilter';
import { ButtonPopup } from '../../features/popup/ButtonPopup/ButtonPopup';
import BlacklistPopupAdapter from '../../features/blacklist/BlacklistPopup/BlacklistPopupAdapter';
import styles from './styles.module.css';
import blockStyles from '../Blocks/style.module.css';
import { PlusOutlined } from '@ant-design/icons';

export const Blacklist: FC = memo(() => {
  const propsBlacklist = useBlacklist();
  return (
    <Blocks
      topBlock={
        <div className={blockStyles.topBlockRow}>
          <SiteMenu
            title="Черный список номеров"
            subtitle="Управление блокировкой номеров"
            svg={true}
            svgType="blacklist"
          />
          <div className={styles.controls}>
            <BlacklistTableFilter
              searchValue={propsBlacklist.callRequest.TextSearch}
              reasonValue={propsBlacklist.reasonValue}
              onReasonChange={propsBlacklist.handleReasonChange}
              onSearch={propsBlacklist.handleSearch}
              onRangePickerChange={propsBlacklist.handleRangePicker}
              dateRange={propsBlacklist.dateRange}
              disabled={propsBlacklist.isLoading}
            />
            <Tooltip title="Добавить номер">
              <span>
                <ButtonPopup
                  title=""
                  isSquared
                  PopupComponent={BlacklistPopupAdapter}
                  extra={{
                    icon: <PlusOutlined />,
                    onSuccess: propsBlacklist.reload,
                  }}
                  disabled={propsBlacklist.isLoading}
                />
              </span>
            </Tooltip>
          </div>
        </div>
      }
      mainBlock={
        <BlacklistTable
          callRequest={propsBlacklist.callRequest}
          pageSize={propsBlacklist.pageSize}
          total={propsBlacklist.total}
          allBlacklist={propsBlacklist.allBlacklist}
          divider={propsBlacklist.divider}
          COLUMNS={propsBlacklist.COLUMNS}
          onChange={propsBlacklist.handleChange}
          onTableChange={propsBlacklist.onTableChange}
          handlePageSizeChange={propsBlacklist.handlePageSizeChange}
          loading={propsBlacklist.isLoading}
          hasLoadError={propsBlacklist.hasLoadError}
        />
      }
    />
  );
});

Blacklist.displayName = 'Blacklist';
